import logo from './logo.svg';
import './App.css';
// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles/style.css';
import './styles/responsive.css';

import { Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsCondition from './Pages/TermsCondition';
import ScrollToTop from './Comoponents/ScrollToTop';

function App() {
  return (
    <>
    <ScrollToTop/>
    <Routes>
      <Route path='/' element={<Home/>}/>
       <Route path="/about-us" element={<Home />} />
        <Route path="/services" element={<Home />} />
         <Route path="/choose-us" element={<Home />} />
          <Route path="/contact-us" element={<Home />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
           <Route path='/terms-condition' element={<TermsCondition/>}/>
    </Routes>
    </>
  );
}

export default App;
